import React from 'react';

export default () => (
  <div style={{ textAlign: 'center' }}>
    <h1>Page not found</h1>
  </div>
);
